import { createApi } from '@reduxjs/toolkit/query/react';
import { backendBaseQuery } from '@shared/api';
import { Segment, CreateSegmentDTO, UpdateSegmentDTO } from '../model/types';

export const segmentsApi = createApi({
  reducerPath: 'segments-api',
  baseQuery: backendBaseQuery,
  tagTypes: ['Segment'],
  endpoints: (build) => ({
    findAll: build.query<Segment[], void>({
      query: () => ({
        url: 'segments',
        method: 'GET'
      }),
      providesTags: [
        {type: 'Segment', id: 'LIST'}
      ]
    }),
    autocomplete: build.query<Segment[], void>({
      query: () => ({
        url: 'segments/autocomplete',
        method: 'GET'
      }),
      providesTags: [
        {type: 'Segment', id: 'LIST'}
      ]
    }),

    findOne: build.query<Segment, string>({
      query: (id) => ({
        url: `segments/${id}`,
        method: 'GET'
      }),
      providesTags: [
        {type: 'Segment', id: 'ID'}
      ]
    }),

    create: build.mutation<Segment, CreateSegmentDTO>({
      query: (body) => ({
        url: 'segments',
        method: 'POST',
        body
      }),
      invalidatesTags: [
        {type: 'Segment', id: 'LIST'}
      ]
    }),

    update: build.mutation<Segment, { _id: string; body: UpdateSegmentDTO }>({
      query: ({ _id, body }) => ({
        url: `segments/${_id}`,
        method: 'PUT',
        body
      }),
      invalidatesTags: [
        {type: 'Segment', id: 'LIST'},
        {type: 'Segment', id: 'ID'}
      ]
    }),

    delete: build.mutation<void, string>({
      query: (id) => ({
        url: `segments/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [
        {type: 'Segment', id: 'LIST'}
      ]
    }),

    toggle: build.mutation<Segment, Segment['_id']>({
      query: (id) => ({
        url: `segments/${id}/toggle-visibility`,
        method: 'POST'
      }),
      invalidatesTags: [
        {type: 'Segment', id: 'LIST'},
      ]
    }),
    getUserFields: build.query<any, void>({
        query: () => ({
          url: `segments/fields`,
          method: 'GET'
        }),
        providesTags: [
          {type: 'Segment', id: 'FIELDS'}
        ]
      }),

  })
});

export const {
  useFindAllQuery,
  useFindOneQuery,
  useCreateMutation,
  useUpdateMutation,
  useDeleteMutation,
  useToggleMutation,
  useGetUserFieldsQuery,
  useAutocompleteQuery
} = segmentsApi; 